import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Xadentra" description="The page you're looking for can't be found." path="/404" />
      <section className="min-h-[70vh] bg-[#07111F] text-white relative overflow-hidden grid place-items-center">
        <div className="xa-blob" style={{ width: 480, height: 480, background: "#6D4DFF", top: -160, left: -120, opacity: 0.5 }} />
        <div className="xa-blob" style={{ width: 360, height: 360, background: "#00D4FF", bottom: -120, right: -80, opacity: 0.3 }} />
        <div className="absolute inset-0 xa-grid-dark opacity-50 pointer-events-none" />
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 text-center relative">
          <div className="font-display text-[10rem] leading-none font-bold tracking-tighter xa-gradient-text">404</div>
          <h1 className="font-display mt-2 text-4xl font-bold tracking-tight">Page not found.</h1>
          <p className="mt-4 text-white/65">The URL has drifted off the orchestration map.</p>
          <Link to="/" data-testid="not-found-home-link" className="mt-10 xa-btn xa-btn-primary">
            Return home
          </Link>
        </div>
      </section>
    </>
  );
}
